import React from "react";
import SkeletonElement from "./SkeletonElement";
import styled from "styled-components";

const SkeletonEdu = () => {
  return (
    <div className="skeleton-wrapper">
      <div className="skeleton-profile">
        <div style={{ display: "flex", gap: "14px" }}>
          <div style={{ width: "48%" }}>
            <div
              style={{
                width: "100%",
                height: "181px",
                backgroundColor: "#E3E3E3",
                borderRadius: "10px",
              }}
            >
              <div className="shimmer-wrapper">
                <div className="shimmer"></div>
              </div>
            </div>
          </div>
          <div style={{ width: "48%" }}>
            <div
              style={{
                width: "100%",
                height: "181px",
                backgroundColor: "#E3E3E3",
                borderRadius: "10px",
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonEdu;
